<script setup lang="ts">
import SrDataTable from '@/components/tables/SrDataTable.vue'
import type { TableColumn } from '@/components/alerts/types'
// import { noExponents } from '@/utils'

interface PoolDebugRow {
  pool: string
  dex: string
  chain_price: number | null
  price_buy: number | null
  price_sell: number | null
  tvl: number | null
  ts: number
}

const props = defineProps<{
  pools: PoolDebugRow[]
}>()

const columns: TableColumn[] = [
  { field: 'pool', header: 'Pool', sortable: true, width: '340px' },
  { field: 'dex', header: 'DEX', sortable: true, width: '120px' },
  { field: 'price_buy', header: 'Price Buy', sortable: true, width: '140px' },
  { field: 'price_sell', header: 'Price Sell', sortable: true, width: '140px' },
  { field: 'tvl', header: 'TVL $', sortable: true, width: '140px' },
  { field: 'ts', header: 'TS', sortable: true, width: '150px' },
]

const formattingRules = {
  price_buy: (v: number | null) => (v),
  price_sell: (v: number | null) => (v),
  tvl: (v: number | null) => (v),
  ts: (v: number) => {
    // Auto-detect seconds vs milliseconds
    const ms = v < 1e12 ? v * 1000 : v
    return new Date(ms).toLocaleString('ru-RU')
  },
}
</script>

<template>
  <SrDataTable size="small" :value="props.pools" :columns="columns" :formatting-rules="formattingRules" />
</template>
